<div >
  <form [formGroup]="inputForm" class="m-asm-customer-search-form">
    <input type="text" class="a-asm-customer-search-form-input"
           placeholder="{{labelText | translate}}"
           name="customerName"
           vTp="customerName"
           formControlName="customer"
           autocomplete="off"
    >
    <v-spinner [activeSpinner]="processing"></v-spinner>
  </form>
</div>

